import Box from '@mui/material/Box';
import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { FullPageLoader, Logo } from '@/shared/ui';

/** Minimal frame for standalone status pages (403/404/500). */
export function SimpleLayout() {
  return (
    <Box
      sx={{
        minHeight: '100dvh',
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ p: { xs: 2, sm: 3 } }}>
        <Logo height={24} />
      </Box>
      <Box component="main" sx={{ flex: 1, display: 'grid', placeItems: 'center', p: 2 }}>
        <Suspense fallback={<FullPageLoader />}>
          <Outlet />
        </Suspense>
      </Box>
    </Box>
  );
}
